import moment from 'moment-jalaali';

export default {
  objToDate(obj) {
    return moment(
        `${obj.year}/${obj.month}/${obj.day}`,
        'jYYYY/jM/jD',
    ).format('YYYY/M/D');
  },
  dateToObj(date) {
    return {
      day: moment(date).jDate(),
      month: moment(date).jMonth() + 1,
      year: moment(date).jYear(),
    };
  },
  isObjValidDate(obj) {
    const date = this.objToDate(obj);
    return moment(date).isValid();
  },
};